import request from '@/utils/request'

// 获取商户下的静态码列表
export function GetMchOnboardQrList(params) {
  return request({
    url: '/merchant-api/merchant/qrStand/mchOnboard/qrList',
    method: 'get',
    params
  })
}

// 创建静态码
export function PostCreateMchOnboardQr(data) {
  return request({
    url: '/merchant-api/merchant/qrStand/mchOnboard/createQr',
    method: 'post',
    data
  })
}

// 商户修改静态码备注信息
export function PostMchOnboardTagQr(data) {
  return request({
    url: '/merchant-api/merchant/qrStand/mchOnboard/tagQr',
    method: 'post',
    data
  })
}


